
export default {
  props: {
    topics: {
      type: Array,
    },
  },
  data() {
    return {
      selectedItems: [],
    };
  },
  methods: {
    isActive(item) {
      return this.selectedItems.includes(item);
    },

    setActiveItem(item) {
      this.selectedItems.push(item);
      this.$emit("change", this.selectedItems);
    },
    removeActiveItem(item) {
      this.selectedItems = this.selectedItems.filter((e) => e !== item);
      this.$emit("change", this.selectedItems);
    },
  },
};
